// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetProvidersFormFields-modulesection__JCXyn";
var _2 = "RequestProfileWidgetProvidersFormFields-modulesections__WhJeR";
export { _1 as "section", _2 as "sections" }
